var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8586 1.10292C10.5163 0.760614 10.0029 0.760614 9.66055 1.10292L1.10286 9.66061C0.931707 9.83177 0.84613 10.0029 0.84613 10.2597V13.6827C0.84613 14.1962 1.18844 14.5385 1.7019 14.5385H5.12498C5.38171 14.5385 5.55286 14.4529 5.72401 14.2818L14.2817 5.72408C14.624 5.38177 14.624 4.86831 14.2817 4.526L10.8586 1.10292ZM4.78269 12.827H2.55769V10.602L7.69231 5.46736L9.91731 7.69236L4.78269 12.827ZM8.89041 4.26928L11.1154 6.49428L12.4846 5.12505L10.2596 2.90005L8.89041 4.26928Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d0c68c14dbd2e769de5506d9ae9fccbe.svg";
export { ForwardRef as ReactComponent };